import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { ConfiguratorStructureService, ConfiguratorTokenService, EngineDataQueryService } from '@tj/tj-dmp-lib-api';
import { ClipboardService } from '../../../services/clipboard.service';
import { MessageService } from "primeng/api";
import { CurrentQuery, FilterPresetService } from "../../../components/filter/filter-preset/filter-preset.service";

@Component({
    selector: 'dmp-export',
    templateUrl: './export.component.html',
    styleUrls: ['./export.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class ExportComponent implements OnInit {

    views = [
        { name: 'Valeurs du tableau', code: 'LIST' },
        { name: 'Toutes les valeurs', code: 'ALL' },
    ] as const;

    view = this.views[0];

    actual: CurrentQuery;
    currentId: string;

    exportedColumns: { codes: string[], labels: string[] };

    @Input() partner: string;
    @Input() selectedTables: string[];
    @Input() selectedColumns: string[];

    constructor(
        //private filterSaveService: FilterSaveListService,
        private filterPresetService: FilterPresetService,
        private engineDataQueryService: EngineDataQueryService,
        private configuratorStructureService: ConfiguratorStructureService,
        private configuratorTokenService: ConfiguratorTokenService,
        private clipboardService: ClipboardService,
        private messageService: MessageService,
        @Inject(DOCUMENT) private document: Document
    ) {
    }

    get disabled() {
        return !this.actual && !this.currentId;
    }

    ngOnInit(): void {
        this.filterPresetService.actual$.subscribe((actual) => this.actual = actual);
        this.filterPresetService.currentId$.subscribe((currentId) => this.currentId = currentId);
    }

    exportCSV() {
        this.getColumnsLabel().then(() => {
            this.engineDataQueryService.downloadSaveQueryUsingGET1(this.actual.datastore, this.partner, this.view.code, this.exportedColumns.codes, this.exportedColumns.labels, this.currentId, null, 'response').subscribe(
                (response) => {
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(new Blob([(response.body as string)]));
                    const fileName = 'export.csv';
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.messageService.add({ key: 'common', severity: 'success', summary: 'Succès', detail: 'Fichier téléchargé' });
                }
            );
        });
    }

    exportPDF() {
        this.getColumnsLabel().then(() => {
            this.engineDataQueryService.downloadSaveQueryDocUsingGET(this.actual.datastore, this.actual.partner ? this.actual.partner : this.partner, this.view.code, 'pdf', this.exportedColumns.codes, this.exportedColumns.labels, this.currentId, null, 'response').subscribe(
                (response) => {
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(new Blob([(response.body as BlobPart)], { type: 'application/pdf' }));
                    const fileName = 'export.pdf';
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.messageService.add({ key: 'common', severity: 'success', summary: 'Succès', detail: 'Fichier téléchargé' });
                }
            );
        });
    }

    exportXLSX() {
        this.getColumnsLabel().then(() => {
            this.engineDataQueryService.downloadSaveQueryDocUsingGET(this.actual.datastore, this.actual.partner ? this.actual.partner : this.partner, this.view.code, 'xlsx', this.exportedColumns.codes, this.exportedColumns.labels, this.currentId, null, 'response').subscribe(
                (response) => {
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(new Blob([(response.body as string)]));
                    const fileName = 'export.xlsx';
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.messageService.add({ key: 'common', severity: 'success', summary: 'Succès', detail: 'Fichier téléchargé' });
                }
            );
        });
    }

    generateToken() {
        this.getColumnsLabel().then(() => {
            this.configuratorTokenService.getOrGenerateSaveQueryTokenUsingPOST(this.currentId, false).subscribe((el) => {
                const columnsParam = this.exportedColumns.codes.map(c => `columns=${encodeURIComponent(c)}`).join('&');
                const labelsParam = this.exportedColumns.labels.map(l => `labels=${encodeURIComponent(l)}`).join('&');
                this.clipboardService.copyToClipboard(`${this.document.location.origin}/services/engine/api/public/v1/download/save-query/csv?groupe=${this.actual.datastore}&partner=${this.actual.partner ? this.actual.partner : this.partner}&displayMode=${this.view.code}&token=${el.uuid}&${columnsParam}&${labelsParam}`);
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Lien de téléchargement copié dans le presse-papiers' });
            });
        });
    }

    getColumnsLabel(): Promise<void> {
        return new Promise((resolve) => {
            const tables: string[] = Array.from(new Set(this.selectedTables));
            const columnsMap: Map<string, string> = new Map();

            const requests = tables.map(table =>
                this.configuratorStructureService.getAllFieldForTableNameUsingGET(this.actual.datastore, table, null).toPromise()
            );

            Promise.all(requests).then(results => {
                results.forEach(fields => {
                    fields.forEach(field => {
                        if (this.selectedColumns.includes(field.code)) {
                            columnsMap.set(field.code, field.label || field.code);
                        }
                    });
                });

                const codes = this.selectedColumns;
                const labels = this.selectedColumns.map(code => columnsMap.get(code) || code);

                this.exportedColumns = { codes, labels };
                resolve();
            });
        });
    }
}
